import { render, staticRenderFns } from "./ActiveAdmin.vue?vue&type=template&id=03862840&"
import script from "./ActiveAdmin.vue?vue&type=script&lang=js&"
export * from "./ActiveAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ActiveAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports